import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root' // Makes the service globally available
})
export class ViewportHeightService {
  constructor() {}

  // Function to set the dynamic viewport height
  setDynamicHeight() {
    const vh = window.innerHeight * 0.01; // Calculate 1% of the actual viewport height
    document.documentElement.style.setProperty('--vh', `${vh}px`); // Set custom CSS variable
    document.body.style.height = `calc(var(--vh, 1vh) * 100)`; // Apply to body
  }
}
